exports.REGULAR_USER = "REGULAR_USER";
exports.ADMIN_USER = "ADMIN_USER";
